import React from "react";
import { ArrowLeftIcon } from "@heroicons/react/24/solid";
import UniversalResults from "./UniversalResults";

export default function SearchResults({
  searchTerm,
  setSearchTerm,
  setIsCollapsed,
}) {
  return (
    <div className="w-72 space-y-6">
      <div className="flex items-center space-x-2">
        <ArrowLeftIcon
          className="h-4 w-4 cursor-pointer"
          onClick={() => {
            setSearchTerm("");
          }}
        />
        <h2 className="text-sm">Back to search history</h2>
      </div>
      <div className="space-y-1">
        <h3 className="text-base font-semibold">Search Results</h3>
        <h4 className="text-sm">
          Showing results for &quot;{searchTerm}&quot;{" "}
        </h4>
        <hr className="border-t border-gray-300" />
      </div>
      <div className="space-y-1">
        <UniversalResults
          searchTerm={searchTerm}
          setIsCollapsed={setIsCollapsed}
        />
      </div>
    </div>
  );
}
